var jquery = require("/js/lib/jquery");

window.$ = window.jQuery = jquery;

import wsCall, { wsCallAsync } from './wsCall';
import appData from './appData';
import { getParameterByName } from './util';
import 'babel-polyfill';
var moment = require('moment-timezone');

function App() {
  var self = this;
}

App.prototype.init = function() {
  var self = this;

  appData.init({
    watch: {
    },
    computed: {
    },
    methods: {
    },
    mounted: function() {
    }
  });

  $('#betaTestSignupButton').on('click', function() {
    $('#betaTestSignupSubmit').click();
  });
  $('#betaTestSignupForm').on('submit', async function(e) {
    e.preventDefault();

    $('#betaTestSignupButton').addClass('is-loading');
    appData.vm.pageloaderText = 'Loading';
    appData.vm.pageloaderVisible = true;

    try {
      let result = await wsCallAsync({
        url: '/account/create',
        data: {
          email: appData.vm.betaTestSignupEmail,
          password: appData.vm.betaTestSignupPassword,
          phone: appData.vm.betaTestSignupPhone,
          name: appData.vm.betaTestSignupName,
          tzClient: moment.tz.guess()
        }
      });

      result = await wsCallAsync({
        url: "/account/login",
        data: {
          email: appData.vm.betaTestSignupEmail,
          resetPasswordId: result.data.resetPasswordId
        }
      });
      result = await wsCallAsync({
        url: '/account/setup',
        data: {
          email: appData.vm.betaTestSignupEmail,
          password: appData.vm.betaTestSignupPassword,
          phone: appData.vm.betaTestSignupPhone,
          name: appData.vm.betaTestSignupName,
        }
      });
      window.location = '/app';
    }
    catch (result) {
    }
  });

};

var app = new App();

app.init();

export default app;

